import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {ViewController} from "ionic-angular/index";

/**
 * Generated class for the MyAlertComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'my-alert',
  templateUrl: 'my-alert.html',
})
export class MyAlertComponent implements OnChanges {
  text: string;

  @Input() alertObj: any;
  @Output() submit = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Input() errorCode:any;

  constructor(public viewCtrl:ViewController) {}

  ngOnChanges(changes: SimpleChanges) {
    // console.log(1);
    // console.log(this.alertObj);
  }

  alertCancel() {
    // this.cancel.emit(true);
    this.viewCtrl.dismiss(false);
  }

  alertSuccess() {
    // this.submit.emit(true);
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/components/my-alert/my-alert.ts